import axios from 'axios'

export const base = axios.create({
    baseURL: "/",
});
export const client = axios.create({
    baseURL: "/",
    withCredentials: true,
    withXSRFToken: true,
    headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
        "X-Frame-Options": "deny",
        "X-Content-Type-Origins": "nosniff",
        "Referrer-Policy": "same-origin"
    },
});

export const debounce = (fn, delay) => {
        let timeoutID = null
        return function () {
          clearTimeout(timeoutID)
          let args = arguments;
          let that = this;
          timeoutID = setTimeout(() => {
            fn.apply(that, args)
          }, delay)
        }
    };
export const inchesToFeet = (inch) =>{
        if(!inch) return '';
        var feet = Math.floor(inch / 12);
        var inches = inch % 12;
        return `${feet}'${inches}"`;
    }

// }

client.interceptors.request.use(
    (config) => {
        return config;
    },
    (error) => {
        return Promise.reject(error.response);
    }
);

/*
 * Add a response interceptor
 */
client.interceptors.response.use(
    (response) => {

        return response;
    },
    (error) => {
        // // if error is unauthenticated user or unauthorized access
        // if ([401,403].indexOf(error.response.status) >= 0) {
        //     Promise.reject(error.statusText);
        //     store.dispatch("logout");
        // }
        // //csrf mismatch?
        // if ([419].indexOf(error.response.status) >= 0) {
        //     Promise.reject('Token Mistmatch');
        // };

        return Promise.reject(error.response);
    }
);
